import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"

    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23950 23949"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#252422}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313088016">
        <path
          d="M23313 4296H637V2442c0-996 809-1805 1805-1805h19066c995 0 1805 809 1805 1805v1854zm0 17211c0 996-810 1805-1805 1805H2442c-996 0-1805-809-1805-1805V4933h22676v16574zM21508 0H2442C1095 0 0 1095 0 2442v19065c0 1347 1095 2442 2442 2442h19066c1346 0 2442-1095 2442-2442V2442c0-1347-1096-2442-2442-2442z"
          className="fil0"
        />
        <path
          d="M6105 12779c512-361 3116-2028 5429-332 671 493 1353 783 2029 861 172 19 354 32 545 32 1107 0 2490-401 3716-1932 399 822 630 1741 630 2715 0 3446-2804 6248-6249 6248-3446 0-6249-2802-6249-6248 0-462 54-910 149-1344zm6100-4905c2224 0 4175 1171 5282 2925-1298 1759-2801 1998-3851 1876-564-64-1145-314-1726-741-2097-1538-4371-697-5525-71 909-2330 3172-3989 5820-3989zm0 13134c3796 0 6885-3089 6885-6885 0-3797-3089-6886-6885-6886-3797 0-6886 3089-6886 6886 0 3796 3089 6885 6886 6885zM20409 1593c-482 0-873 391-873 873s391 874 873 874 873-392 873-874-391-873-873-873zM17558 1593c-482 0-873 391-873 873s391 874 873 874c483 0 873-392 873-874s-391-873-873-873zM2988 2785h2331v-637H2988z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
